import "./Channel.scss";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";

import queryString from "querystring";

import { Button, Form, Input, Row, Spin } from "antd";

import partnersApi from "../../apis/Partners.api";
import { setLoading } from "../../redux/store/common/commonDuck";

const Search = () => {
	const history = useHistory();
	const location = useLocation();

	const queryJson = queryString.parse(location.search?.replace("?", ""));
	const searchValue = queryJson?.query;

	// const searchValue = decodeURI(location.search.split("query=")[1]);
	const reduxChannel = useSelector((state) => state.channel.reduxChannel);
	const [videoList, setVideoList] = useState([]);
	const [productList, setProductList] = useState([]);
	const [ingredientList, setIngredientList] = useState([]);
	const dispatch = useDispatch();

	const isLoading = useSelector((state) => state.common.loading);
	const setIsLoading = (value) => dispatch(setLoading(value));
	const second = (Math.random() * 10).toFixed();
	const bgIngredient = ["#117FFA", "#78B8FF", "#0051AB", "#4791E3"];

	useEffect(() => {
		if (searchValue?.length) {
			getSearch();
		}
	}, [searchValue, reduxChannel]);

	const getSearch = async () => {
		setIsLoading(true);
		let param = {
			// offset: offset,
			// pageSize: pageSize,
			searchWord: searchValue ?? "",
			influencerId: reduxChannel?.user_id,
			// influencerId: 1,
		};
		const res = await partnersApi.readSearchList(param);
		if (res.code === 200) {
			// setSearchList(res.result.searchResultList);
			// setTotalCnt(res.result.totalCnt);
			setIngredientList(
				res.result.totalIngredientList?.map((item) => ({
					...item,
					bg_color:
						reduxChannel?.user_id === 7
							? item.is_hot
								? "#fe2b4b"
								: item.is_best
								? "#ff8000"
								: reduxChannel?.color_2
								? reduxChannel?.color_2
								: null
							: item.is_hot
							? "#FF8000"
							: item.is_best
							? "#005DA9"
							: reduxChannel?.color_2
							? reduxChannel?.color_2
							: null,
					// bg_color: item.is_hot ? "#fe2b4b" :
					//     item.is_best ? "#ff8000" :
					//         reduxChannel?.color_2 ? reduxChannel?.color_2 : "#272847"
				}))
			);
			setVideoList(res.result?.associatedVideoList);
			setProductList(res.result?.productList);
			// console.log(res.result);
			window.scrollTo({
				top: 0,
				behavior: "smooth",
			});
		} else {
			setVideoList([]);
			setProductList([]);
			// setTotalCnt(0);
			window.scrollTo({
				top: 0,
				behavior: "smooth",
			});
		}
		setIsLoading(false);
	};

	/**
	 * page 넘김
	 */
	// const handleChangePagination = (pageNumber) => {
	//     const currOffset = (pageNumber - 1) * pageSize;
	//     setCurrentPageNumber(pageNumber);
	//     setOffset(currOffset);
	//     getSearch(currOffset);
	// };

	const [isMobile, setIsMobile] = useState(null);
	useEffect(() => {
		if (typeof window !== "undefined") {
			const matchQueryList = window.matchMedia("all and (max-width: 768px)");
			setIsMobile(matchQueryList.matches);

			const media = function handleChange(e) {
				setIsMobile(e.matches);
			};

			matchQueryList.addEventListener("change", media);
		}
	}, []);
	return (
		<div className="main-wrap">
			<div
				className={`home-header`}
				style={{
					backgroundColor: "#e9ecef",
					borderRadius: "8px",
				}}
			>
				<div
					className={`home-title-div`}
					style={{ gap: "1.5em", padding: "3em" }}
				>
					<h1 className={`home-title`} style={{ color: "#212529" }}>
						{searchValue}
					</h1>
					<Form size={`large`}>
						<Input.Search
							className={`home-search-bar`}
							type={`text`}
							placeholder={`${
								isMobile
									? `검색 예시) ${
											reduxChannel?.placeholder
												? reduxChannel?.placeholder
												: "비타민"
									  }`
									: reduxChannel?.user_id === 9
									? `증상 검색하기 (예시: ${
											reduxChannel?.placeholder
												? reduxChannel?.placeholder
												: "비타민"
									  })`
									: `증상, 영양제 검색하기 (예시: ${
											reduxChannel?.placeholder
												? reduxChannel?.placeholder
												: "비타민"
									  })`
							}`}
							allowClear
							// value={searchValue}
							// onChange={(e) => {
							//     setSearchValue(e.target.value);
							// }}
							onSearch={(value) => {
								if (value?.length > 0) {
									history.push(
										`/together/channel/search?query=${value}&id=${reduxChannel?.influencer_id}`
									);
								} else {
									history.push(
										`/together/channel/ingredients?id=${reduxChannel?.influencer_id}`
									);
								}
							}}
						/>
					</Form>
				</div>
			</div>
			<div className={`home-body search-body`}>
				{/* 관련 영상 */}
				{/*<p className={`search-count`}>*/}
				{/*    관련 영상 {!isLoading && `${videoList?.length}개`}*/}
				{/*</p>*/}
				{/*{isLoading ? (*/}
				{/*    <Spin style={{margin: "auto", width: "100%", paddingTop: "2em"}}/>*/}
				{/*) : (*/}
				{/*    <>*/}
				{/*        {videoList?.length > 0 ? (*/}
				{/*            <div className={`search-each`}>*/}
				{/*                <div className={`youtube-group`} style={{width: "100%"}}>*/}
				{/*                    {videoList.map((item, idx) => (*/}
				{/*                        <button*/}
				{/*                            className={`youtube-each`}*/}
				{/*                            key={`관련 영상 보기 ${idx}`}*/}
				{/*                            onClick={() => {*/}
				{/*                                window.open(item?.url);*/}
				{/*                            }}*/}
				{/*                        >*/}
				{/*                            <img*/}
				{/*                                src={`/assets/images/channel/youtube.png`}*/}
				{/*                                alt={`유튜브 아이콘`}*/}
				{/*                                style={{*/}
				{/*                                    width: "auto",*/}
				{/*                                    height: "1.5em"*/}
				{/*                                }}*/}
				{/*                            />*/}
				{/*                            <span>{item?.title}</span>*/}
				{/*                        </button>*/}
				{/*                    ))}*/}
				{/*                </div>*/}
				{/*            </div>*/}
				{/*        ) : (*/}
				{/*            <Row align={"middle"} style={{width: "100%", flexDirection: "column", padding: "3em 0"}}>*/}
				{/*                <img*/}
				{/*                    src={`/assets/images/warning.png`}*/}
				{/*                    alt={`warning-icon`}*/}
				{/*                    style={{*/}
				{/*                        width: "3.5em",*/}
				{/*                        height: "auto"*/}
				{/*                    }}*/}
				{/*                />*/}
				{/*                <span style={{*/}
				{/*                    marginTop: "1em", color: "#adb5bd", fontSize: "1.2em", fontWeight: 500*/}
				{/*                }}>*/}
				{/*                검색 결과가 없습니다.*/}
				{/*            </span>*/}
				{/*            </Row>*/}
				{/*        )}*/}
				{/*    </>*/}
				{/*)}*/}
				{isLoading ? (
					<Spin style={{ margin: "auto", width: "100%", paddingTop: "2em" }} />
				) : (
					<>
						<>
							<p className={`search-count`} style={{ paddingTop: "2em" }}>
								관련 카테고리 {!isLoading && `${ingredientList?.length}개`}
							</p>
							{ingredientList?.length > 0 ? (
								<div
									className={`channel-flex-wrap`}
									style={{ padding: "1em 0" }}
								>
									{ingredientList?.map((item, idx) => (
										<button
											className={`content-button`}
											key={`ingredient-each-${idx}`}
											onClick={() =>
												history.push(
													`/together/channel/ingredients/detail/${item?.ingredient_id}?id=${reduxChannel?.influencer_id}`
												)
											}
										>
											<div
												className={`channel-home-button-header not-description`}
												style={{
													borderRadius: 5,
													background: `${
														item?.bg_color
															? item?.bg_color
															: bgIngredient[(second + idx) % 4]
													} no-repeat right/100% url("${
														process.env.REACT_APP_HOST
													}/assets/images/channel/button-bg-${
														(second + idx) % 4
													}.png")`,
												}}
											>
												<p>{item?.ingredient_name}</p>
												<img
													src={`/assets/images/channel/arrow.png`}
													alt={`화살표`}
													style={{
														height: "auto",
														width: "1em",
													}}
												/>
											</div>
										</button>
									))}
								</div>
							) : (
								<Row
									align={"middle"}
									style={{
										width: "100%",
										flexDirection: "column",
										padding: "3em 0",
									}}
								>
									<img
										src={`/assets/images/warning.png`}
										alt={`warning-icon`}
										style={{
											width: "3.5em",
											height: "auto",
										}}
									/>
									<span
										style={{
											marginTop: "1em",
											color: "#adb5bd",
											fontSize: "1.2em",
											fontWeight: 500,
										}}
									>
										검색 결과가 없습니다.
									</span>
								</Row>
							)}
						</>

						{/* 관련 영양제 */}
						{reduxChannel?.user_id !== 8 && reduxChannel?.user_id !== 9 && (
							<>
								<p className={`search-count`} style={{ paddingTop: "2em" }}>
									관련 영양제 {!isLoading && `${productList?.length}개`}
								</p>
								{productList?.length > 0 ? (
									<div className={`search-each`}>
										<div className={`product-search-recommend-wrap`}>
											{productList.map((item, idx) => (
												<div
													className={`product-search-each`}
													key={`관련 영양제 검색 ${idx}`}
													onClick={() =>
														history.push(
															`/together/channel/ingredients/detail/${item?.category_id}?id=${reduxChannel?.influencer_id}`
														)
													}
												>
													<img
														src={
															item?.target_id
																? `${process.env.REACT_APP_CDN}/image/recommend/${item.target_id}.jpg`
																: `${process.env.REACT_APP_S3_HOST}/image/together/${reduxChannel?.influencer_id}/${item.id}.${item.img_type}`
														}
														onError={({ currentTarget }) => {
															currentTarget.onerror = null; // prevents looping
															// currentTarget.style.display = "none";
															currentTarget.src = `/assets/images/no-product.png`;
														}}
														alt={`${item.brand_name} ${item.product_name}`}
														className={`product-image`}
													/>
													<div className={`tag-list`}>
														{item?.categoryList?.map((item, idx) => {
															if (idx < 2) {
																return (
																	<Button
																		className={`tag`}
																		key={`category-tag ${idx}`}
																		onClick={() =>
																			history.push(
																				`/together/channel/search?query=${item.category_name}`
																			)
																		}
																	>
																		{item.category_name}
																	</Button>
																);
															}
														})}
													</div>
													<p
														className={`brand-name`}
														style={{ fontSize: "1em" }}
													>
														{item.brand_name}
													</p>
													<p className={`product-name`}>{item.product_name}</p>
													<p className={`sub-title`}>{item.sub_title}</p>
												</div>
											))}
										</div>
									</div>
								) : (
									<Row
										align={"middle"}
										style={{
											width: "100%",
											flexDirection: "column",
											padding: "3em 0",
										}}
									>
										<img
											src={`/assets/images/warning.png`}
											alt={`warning-icon`}
											style={{
												width: "3.5em",
												height: "auto",
											}}
										/>
										<span
											style={{
												marginTop: "1em",
												color: "#adb5bd",
												fontSize: "1.2em",
												fontWeight: 500,
											}}
										>
											검색 결과가 없습니다.
										</span>
									</Row>
								)}
							</>
						)}
					</>
				)}
			</div>
			{/*<Pagination*/}
			{/*    className="report-pagination-wrap"*/}
			{/*    showSizeChanger={false}*/}
			{/*    current={currentPageNumber}*/}
			{/*    pageSize={pageSize}*/}
			{/*    total={totalCnt}*/}
			{/*    onChange={handleChangePagination}*/}
			{/*/>*/}
		</div>
	);
};
export default Search;
